import { RAMQInfo } from "@/Common/Models/RAMQ/RAMQInfo";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";
import { BaseServerOperationHandler } from "@/Common/Stores/Handlers/Server/BaseServerOperationHandler";
import { PatientStore } from "@/Patient/Stores/PatientStore";

class PatientRAMQEnrolmentResponseHandler extends BaseServerOperationHandler {
    constructor(action: BaseAction) {
        super(action);

        this.RegisterOperation(ServerOperations.Server.RAMQ_CheckSubscription, this.UpdateRamqInfo);
        this.RegisterOperation(ServerOperations.Server.RAMQ_Inscription, this.InscriptionRAMQ);
        this.RegisterOperation(ServerOperations.Server.RAMQ_EditResident, this.EditResident);
        this.RegisterOperation(ServerOperations.Server.RAMQ_EditRepresentant, this.EditRep);
        this.RegisterOperation(ServerOperations.Server.RAMQ_DeleteResident, this.DeleteResident);
        this.RegisterOperation(ServerOperations.Server.RAMQ_DeleteRepresentant, this.DeleteRep);
        this.RegisterOperation(ServerOperations.Server.RAMQ_ChangeEffectiveDate, this.ChangeEffectiveDate);
        this.RegisterOperation(ServerOperations.Server.RAMQ_EditLocationSite, this.EditLocation);
        this.RegisterOperation(ServerOperations.Server.RAMQ_SetRamqPathology, this.EditPathology);
        this.RegisterOperation(ServerOperations.Server.RAMQ_DeInscription, this.TerminateEnrollment);
    }

    private UpdateRamqInfo(response: ServerEvent, store: PatientStore): void {
        let data = new RAMQInfo().FromResponse(response);
        let patient = store.PatientModels[response.PatientId];
        if (patient)
            patient.setRamq(data);
    }

    private ChangeEffectiveDate(response: ServerEvent, store: PatientStore): void {
        let enrollmentModel = store.PatientProfileEnrollmentModels[response.PatientId];

        let inscription = response.Data["RAMQInscription"];

        if (inscription) {
            let errors = inscription.ErrorMessages;

            if (errors && errors.length > 0) {
                enrollmentModel = enrollmentModel.set("RAMQErrors", Immutable.List<string>(errors));
                enrollmentModel = enrollmentModel.set("IsRAMQErrorDialogVisible", true);
            }
            else {
                enrollmentModel = enrollmentModel.set("RAMQErrors", null);
                enrollmentModel = enrollmentModel.set("IsRAMQErrorDialogVisible", false);
                enrollmentModel = enrollmentModel.set("IsInEnrollmentEditMode", false);
                sessionStore.hideGlobalOverlay();
            }

            store.PatientProfileEnrollmentModels[response.PatientId] = enrollmentModel;
            let patientModel = store.PatientModels[response.PatientId];
            store.ActionsProfile.loadRamqInfo(patientModel);
        }
    }

    private DeleteResident(response: ServerEvent, store: PatientStore): void {
        let enrollmentModel = store.PatientProfileEnrollmentModels[response.PatientId];
        let inscription = response.Data["RAMQInscription"];

        if (inscription) {
            let errors = inscription.ErrorMessages;

            if (errors && errors.length > 0) {
                enrollmentModel = enrollmentModel.set("RAMQErrors", Immutable.List<string>(errors));
                enrollmentModel = enrollmentModel.set("IsRAMQErrorDialogVisible", true);
            }
            else {
                enrollmentModel = enrollmentModel.set("RAMQErrors", null);
                enrollmentModel = enrollmentModel.set("IsRAMQErrorDialogVisible", false);
                enrollmentModel = enrollmentModel.set("IsInResidentDeleteMode", false);
                sessionStore.hideGlobalOverlay();
            }

            store.PatientProfileEnrollmentModels[response.PatientId] = enrollmentModel;
            let patientModel = store.PatientModels[response.PatientId];
            store.ActionsProfile.loadRamqInfo(patientModel);
        }
    }

    private DeleteRep(response: ServerEvent, store: PatientStore): void {
        let enrollmentModel = store.PatientProfileEnrollmentModels[response.PatientId];
        let inscription = response.Data["RAMQInscription"];

        if (inscription) {
            let errors = inscription.ErrorMessages;

            if (errors && errors.length > 0) {
                enrollmentModel = enrollmentModel.set("RAMQErrors", Immutable.List<string>(errors));
                enrollmentModel = enrollmentModel.set("IsRAMQErrorDialogVisible", true);
            }
            else {
                enrollmentModel = enrollmentModel.set("RAMQErrors", null);
                enrollmentModel = enrollmentModel.set("IsRAMQErrorDialogVisible", false);
                enrollmentModel = enrollmentModel.set("IsInRepDeleteMode", false);
                sessionStore.hideGlobalOverlay();
            }

            store.PatientProfileEnrollmentModels[response.PatientId] = enrollmentModel;
            sessionStore.hideGlobalOverlay();
            let patientModel = store.PatientModels[response.PatientId];
            store.ActionsProfile.loadRamqInfo(patientModel);
        }
    }

    private EditResident(response: ServerEvent, store: PatientStore): void {
        let enrollmentModel = store.PatientProfileEnrollmentModels[response.PatientId];
        let inscription = response.Data["RAMQInscription"];

        if (inscription) {
            let errors = inscription.ErrorMessages;

            if (errors && errors.length > 0) {
                enrollmentModel = enrollmentModel.set("RAMQErrors", Immutable.List<string>(errors));
                enrollmentModel = enrollmentModel.set("IsRAMQErrorDialogVisible", true);
            }
            else {
                enrollmentModel = enrollmentModel.set("RAMQErrors", null);
                enrollmentModel = enrollmentModel.set("IsRAMQErrorDialogVisible", false);
                enrollmentModel = enrollmentModel.set("IsInResidentEditMode", false);
                sessionStore.hideGlobalOverlay();
                let patientModel = store.PatientModels[response.PatientId];
                store.ActionsProfile.loadRamqInfo(patientModel);
            }

            store.PatientProfileEnrollmentModels[response.PatientId] = enrollmentModel;
        }
    }

    private EditRep(response: ServerEvent, store: PatientStore): void {
        let enrollmentModel = store.PatientProfileEnrollmentModels[response.PatientId];
        let inscription = response.Data["RAMQInscription"];

        if (inscription) {
            let errors = inscription.ErrorMessages;

            if (errors && errors.length > 0) {
                enrollmentModel = enrollmentModel.set("RAMQErrors", Immutable.List<string>(errors));
                enrollmentModel = enrollmentModel.set("IsRAMQErrorDialogVisible", true);
            }
            else {
                enrollmentModel = enrollmentModel.set("RAMQErrors", null);
                enrollmentModel = enrollmentModel.set("IsRAMQErrorDialogVisible", false);
                enrollmentModel = enrollmentModel.set("IsInRepEditMode", false);
                sessionStore.hideGlobalOverlay();
                let patientModel = store.PatientModels[response.PatientId];
                store.ActionsProfile.loadRamqInfo(patientModel);
            }

            store.PatientProfileEnrollmentModels[response.PatientId] = enrollmentModel;
        }
    }

    private EditLocation(response: ServerEvent, store: PatientStore): void {
        let enrollmentModel = store.PatientProfileEnrollmentModels[response.PatientId];
        let inscription = response.Data["RAMQInscription"];

        if (inscription) {
            let errors = inscription.ErrorMessages;

            if (errors && errors.length > 0) {
                enrollmentModel = enrollmentModel.set("RAMQErrors", Immutable.List<string>(errors));
                enrollmentModel = enrollmentModel.set("IsRAMQErrorDialogVisible", true);
            }
            else {
                enrollmentModel = enrollmentModel.set("RAMQErrors", null);
                enrollmentModel = enrollmentModel.set("IsRAMQErrorDialogVisible", false);
                enrollmentModel = enrollmentModel.set("IsInLieuSuiviEditMode", false);
                sessionStore.hideGlobalOverlay();
                let patientModel = store.PatientModels[response.PatientId];
                store.ActionsProfile.loadRamqInfo(patientModel);
            }

            store.PatientProfileEnrollmentModels[response.PatientId] = enrollmentModel;
        }
    }

    private EditPathology(response: ServerEvent, store: PatientStore): void {
        let enrollmentModel = store.PatientProfileEnrollmentModels[response.PatientId];
        let inscription = response.Data["RAMQPathology"];

        if (inscription) {
            let errors = inscription.ErrorMessages;

            if (errors && errors.length > 0) {
                enrollmentModel = enrollmentModel.set("RAMQErrors", Immutable.List<string>(errors));
                enrollmentModel = enrollmentModel.set("IsRAMQErrorDialogVisible", true);
            }
            else {
                enrollmentModel = enrollmentModel.set("RAMQErrors", null);
                enrollmentModel = enrollmentModel.set("IsRAMQErrorDialogVisible", false);
                enrollmentModel = enrollmentModel.set("IsInCaracteristiqueSanteEditMode", false);
                sessionStore.hideGlobalOverlay();
                let patientModel = store.PatientModels[response.PatientId];
                store.ActionsProfile.loadRamqInfo(patientModel);

                if (inscription.InfoMessages && inscription.InfoMessages.length) {
                    sessionStore.showPopup({
                        title: "Message RAMQ",
                        content: inscription.InfoMessages
                    });
                }
            }

            store.PatientProfileEnrollmentModels[response.PatientId] = enrollmentModel;
        }
    }

    private TerminateEnrollment(response: ServerEvent, store: PatientStore): void {
        let enrollmentModel = store.PatientProfileEnrollmentModels[response.PatientId];
        let inscription = response.Data["RAMQInscription"];

        if (inscription) {
            let errors = inscription.ErrorMessages;

            if (errors && errors.length > 0) {
                enrollmentModel = enrollmentModel.set("RAMQErrors", Immutable.List<string>(errors));
                enrollmentModel = enrollmentModel.set("IsRAMQErrorDialogVisible", true);
            }
            else {
                enrollmentModel = enrollmentModel.set("RAMQErrors", null);
                enrollmentModel = enrollmentModel.set("IsRAMQErrorDialogVisible", false);
                enrollmentModel = enrollmentModel.set("IsTerminateEnrollmentPopup", false);

                // reload ramqInfo enrollment & info for patient banner
                let patientModel = store.PatientModels[response.PatientId];
                store.ActionsProfile.loadRamqInfo(patientModel);
                sessionStore.hideGlobalOverlay();
                ramqStore.EmitChangeToListeners();
            }

            store.PatientProfileEnrollmentModels[response.PatientId] = enrollmentModel;
        }
    }

    private InscriptionRAMQ(response: ServerEvent, store: PatientStore): void {
        if (response.Data["NeedPrinting"]) {
            var patientModel = store.PatientModels[response.PatientId];
            store.ActionsProfile.generateRamqForm(patientModel, false);
        }

        let enrollmentModel = store.PatientProfileEnrollmentModels[response.PatientId];
        let inscriptionResult = response.Data["RAMQInscriptionResult"];

        if (inscriptionResult) {
            let errors = inscriptionResult.ErrorMessages;

            if (errors) {
                enrollmentModel = enrollmentModel.set("RAMQErrors", Immutable.List<string>(errors));
                enrollmentModel = enrollmentModel.set("IsRAMQErrorDialogVisible", true);
            }
            else {
                enrollmentModel = enrollmentModel.set("RAMQErrors", null);
                enrollmentModel = enrollmentModel.set("IsRAMQErrorDialogVisible", false);
                enrollmentModel = enrollmentModel.set("IsEnrollmentFormEdit", false);

                // reload ramqInfo for patient banner
                let patientModel = store.PatientModels[response.PatientId];
                store.ActionsProfile.loadRamqInfo(patientModel);
                sessionStore.hideGlobalOverlay();
                ramqStore.EmitChangeToListeners();
            }

            if (inscriptionResult.QuestionCode && inscriptionResult.QuestionCode > 0) {
                enrollmentModel = enrollmentModel.set("RAMQQuestionCode", inscriptionResult.QuestionCode);
                enrollmentModel = enrollmentModel.set("IsRAMQErrorDialogVisible", false);
                enrollmentModel = enrollmentModel.set("IsRAMQQuestionDialogVisible", true);
                sessionStore.hideGlobalOverlay();
            }
            else {
                enrollmentModel = enrollmentModel.set("RAMQQuestionCode", -10);
                enrollmentModel = enrollmentModel.set("IsRAMQQuestionDialogVisible", false);
            }

            enrollmentModel = enrollmentModel.set("RAMQResultCode", inscriptionResult.Result);
            if (inscriptionResult.QuestionCode && inscriptionResult.QuestionCode <= 0) {
                sessionStore.hideGlobalOverlay();
                let patientModel = store.PatientModels[response.PatientId];
                store.ActionsProfile.loadRamqInfo(patientModel);
            }
        }

        store.PatientProfileEnrollmentModels[response.PatientId] = enrollmentModel;
    }
}

export { PatientRAMQEnrolmentResponseHandler };
